import { useEffect, useState } from "react";
import { readMedia } from "./assetCache";

// Resolves a media URL from the API to the downloaded copy on this device
// when there is one (as a blob: URL), otherwise the original URL. Returns
// undefined for the few milliseconds the cache lookup takes, so a <video>
// or <audio> gets its final src once rather than switching sources after
// playback has started.
export function useLocalAsset(url: string | undefined): string | undefined {
  const [resolved, setResolved] = useState<{ url: string; src: string } | null>(null);

  useEffect(() => {
    if (!url) return undefined;
    let objectURL: string | null = null;
    let active = true;
    void readMedia(url).then((blob) => {
      if (!active) return;
      if (blob) objectURL = URL.createObjectURL(blob);
      setResolved({ url, src: objectURL ?? url });
    });
    return () => {
      active = false;
      if (objectURL) URL.revokeObjectURL(objectURL);
    };
  }, [url]);

  return resolved && resolved.url === url ? resolved.src : undefined;
}
